import React, { useEffect, useRef, useState } from 'react';
import { Button, Form, InputGroup } from 'react-bootstrap';
import Keyboard from 'react-simple-keyboard';
import 'react-simple-keyboard/build/css/index.css';

export default function MyKeyboard(props) {
  const { input, setInput, isVisible, setIsVisible, found } = props;
  const [layoutX, setLayoutX] = useState('default');
  const keyboard = useRef();

  const onChange = (input) => {
    setInput(input);
  };

  const handleShift = () => {
    const newLayoutName = layoutX === 'default' ? 'shift' : 'default';
    setLayoutX(newLayoutName);
  };

  const onKeyPress = (button) => {
    if (button === '{enter}') {
      setIsVisible(false);
      if (!found) {
        setInput('');
      }
    }
    if (
      (button === '{shift}' || button === '{lock}') &&
      layoutX === 'default'
    ) {
      setLayoutX('shift');
    } else if (
      (button === '{shift}' || button === '{lock}') &&
      layoutX === 'shift'
    ) {
      setLayoutX('default');
    }
  };

  const onChangeInput = (event) => {
    const input = event.target.value;
    setInput(input);
    keyboard.current.setInput(input);
  };

  useEffect(() => {
    if (isVisible) {
      setInput('');
      keyboard.current.setInput('');
    }
  }, [isVisible]);

  return (
    <div
      className="App"
      style={{ visibility: isVisible ? 'visible' : 'hidden' }}
    >
      <InputGroup size="lg">
        <Button
          variant="danger"
          onClick={() => {
            setIsVisible(false);
            if (!found) {
              setInput('');
            }
          }}
        >
          Kapat
        </Button>
        <Button
          variant="warning"
          onClick={() => {
            setInput('');
            keyboard.current.setInput('');
          }}
        >
          Temizle
        </Button>
        <Form.Control
          autoFocus={true}
          className="border border-warning bg-white text-warning"
          onChange={(e) => setInput(e.target.value)}
          value={input}
        />
        <Button
          variant="warning"
          onClick={() => {
            setInput('');
            keyboard.current.setInput('');
          }}
        >
          Temizle
        </Button>
        <Button
          variant="danger"
          onClick={() => {
            setIsVisible(false);
            if (!found) {
              setInput('');
            }
          }}
        >
          Kapat
        </Button>
      </InputGroup>
      <Keyboard
        layout={{
          default: [
            '" 1 2 3 4 5 6 7 8 9 0 * - # {bksp}',
            '{tab} q w e r t y u ı o p ğ ü [ ]',
            '{lock} a s d f g h j k l ş i , {enter}',
            '{shift} < z x c v b n m ö ç . | $ € {shift}',
            '.com @ {space}',
          ],
          shift: [
            "é ! ' ^ + % & / ( ) = ? _ ~ {bksp}",
            '{tab} Q W E R T Y U I O P Ğ Ü { }',
            '{lock} A S D F G H J K L Ş İ ; {enter}',
            '{shift} > Z X C V B N M Ö Ç : \\ ` ´ {shift}',
            '.com @ {space}',
          ],
        }}
        keyboardRef={(r) => (keyboard.current = r)}
        layoutName={layoutX}
        onChange={onChange}
        onKeyPress={onKeyPress}
      />
    </div>
  );
}
